module.exports = __webpack_public_path__ + "static/media/no_user.f271bca7.png";